import React, { useEffect, useMemo } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { fetcher } from "../../utils/fetcher";
import FullScreenLoader from "../../sharedUI/FullScreenLoader";
import Navigation from "../ui/Navigation";

const ProtectedRoute = ({
  globalState,
  setGlobalState,
  notify,
  modal,
  closeModal,
}) => {
  const { appLoading: loading } = globalState;
  const navigate = useNavigate();
  const location = useLocation();

  const hideNav = useMemo(() => {
    const navHiddenRoutes = ["/profile", "/course/edit"];
    return navHiddenRoutes.some((hiddenRoute) =>
      location.pathname.includes(hiddenRoute)
    );
  }, [location]);

  //Functions
  const checkUser = () => {
    const storedToken = localStorage.getItem("bg-kurswebb-admin-token");
    const { token, user } = globalState;
    if (token && user) {
      handleAuthenticated();
    } else if (storedToken) {
      handlePreviouslyAuthenticated();
    } else {
      handleUnauthenticated();
    }
  };

  const verifyToken = async (token) => {
    const { err, data } = await fetcher({
      path: "admin-auth/verify-token",
      auth: token,
    });
    if (err) return false;
    else return data;
  };

  const handleAuthenticated = () => {
    finishLoading();
  };

  const handlePreviouslyAuthenticated = async () => {
    const storedToken = localStorage.getItem("bg-kurswebb-admin-token");
    const user = await verifyToken(storedToken);
    if (!user) return handleUnauthenticated();
    setGlobalState({
      ...globalState,
      token: storedToken,
      user,
    });
  };

  const handleUnauthenticated = () => {
    navigate("/login", { replace: true });
    finishLoading();
  };

  const finishLoading = () => {
    setGlobalState({
      ...globalState,
      appLoading: false,
    });
  };

  //Effects
  useEffect(() => {
    checkUser();
    //eslint-disable-next-line
  }, [globalState.user]);

  if (loading) return <FullScreenLoader />;
  else
    return (
      <>
        <Navigation
          globalState={globalState}
          setGlobalState={setGlobalState}
          notify={notify}
          hideNav={hideNav}
        />
        <main>
          <Outlet
            context={{
              globalState,
              setGlobalState,
              notify,
              modal,
              closeModal,
            }}
          />
        </main>
      </>
    );
};

export default ProtectedRoute;
